import React, { useEffect, useRef, useState } from "react";
import logo from "../assets/images/logo/logo.svg";
import MobileMenu from "./MobileMenu";
import { useSmoothScrollContext } from "../context/SmoothScrollContext";

const Header = () => {
  const [activeMobileMenu, setActiveMobileMenu] = useState(false);
  const { handleLinkClick } = useSmoothScrollContext();
  const scrollNav = useRef(null);

  useEffect(() => {
    // scrolling nav
    window.addEventListener("scroll", () => {
      let windowScroll = window.scrollY > 100;
      scrollNav.current.classList.toggle("rt-sticky-active", windowScroll);
      scrollNav.current.classList.toggle("sticky", windowScroll);
    });
  }, []);

  return (
      <>
        <header
            className="site-header home-one-header top-0 w-full z-[999] rt-sticky"
            ref={scrollNav}
        >
          <div className="main-header py-6">
            <div className="container">
              <div className="flex items-center justify-between">
                <a
                    href="#home"
                    onClick={(e) => handleLinkClick(e, 'home')}
                    className="brand-logo flex-none lg:mr-10 md:w-auto max-w-[120px]"
                >
                  <img src={logo} alt="logo" className="w-20" />
                </a>
                <div className="flex items-center flex-1">
                  <div className="flex-1 main-menu relative mr-[74px]">
                    <ul className="menu-active-classNamees">
                      <li>
                        <a
                            href="#why-vatel"
                            onClick={(e) => handleLinkClick(e, 'why-vatel')}
                        >
                          Pourquoi Vatel ?
                        </a>
                      </li>
                      <li>
                        <a
                            href="#formations"
                            onClick={(e) => handleLinkClick(e, 'formations')}
                        >
                          Formations
                        </a>
                      </li>
                      <li>
                        <a
                            href="#pedagogie"
                            onClick={(e) => handleLinkClick(e, 'pedagogie')}
                        >
                          Pédagogie
                        </a>
                      </li>
                      <li>
                        <a
                            href="#tauxinsertion"
                            onClick={(e) => handleLinkClick(e, 'tauxinsertion')}
                        >
                          Taux d’insertion
                        </a>
                      </li>
                    </ul>

                  </div>
                  <div className="flex-none flex space-x-[18px]">
                    <div className="hidden lg:block">
                      <a
                          id="btn-brochure-header"
                          href="#brochure"
                          onClick={(e) => handleLinkClick(e, 'brochure')}
                          className="btn tw-bg-secondary text-white hover:tw-bg-primary py-[15px] px-8"
                      >
                        Brochure
                      </a>
                    </div>
                    <div className="block lg:hidden">
                      <div className="flex items-center gap-3">
                        <a
                            id="btn-brochure-header-mobile"
                            href="#brochure"
                            onClick={(e) => handleLinkClick(e, 'brochure')}
                            className="h-10 md:h-[56px] flex items-center justify-center btn tw-bg-secondary text-white hover:tw-bg-primary px-6"
                        >
                          Brochure
                        </a>
                        <button
                            type="button"
                            className="text-3xl md:w-[56px] h-10 w-10 md:h-[56px] rounded bg-[#F8F8F8] flex flex-col items-center justify-center menu-click ml-2"
                            onClick={() => setActiveMobileMenu(!activeMobileMenu)}
                        >
                          <iconify-icon
                              icon="cil:hamburger-menu"
                              rotate="180deg"
                          ></iconify-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        {activeMobileMenu && (
            <MobileMenu
                activeMenu={activeMobileMenu}
                setActiveMenu={setActiveMobileMenu}
                onLinkClick={handleLinkClick}
            />
        )}
      </>
  );
};

export default Header;